<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter-title---IVP" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Contents</h2>
<div id="_idContainer004">
<p class="firstleft"><a href="#/Text/howtouse#_idTextAnchor001">How to Use This Study Guide</a></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch1#_idTextAnchor002" title="Link target outside of Sample">1 A Theological Vision for Slow Church</span></p>
<p class="firstleft"><span href="#/Text/ch2#_idTextAnchor003" title="Link target outside of Sample">2 Terroir</span></p>
<p class="body"><span href="#/Text/ch2#_idTextAnchor003" title="Link target outside of Sample">Taste and See</span></p>
<p class="firstleft"><span href="#/Text/ch3#_idTextAnchor005" title="Link target outside of Sample">3 Stability</span></p>
<p class="body"><span href="#/Text/ch3#_idTextAnchor005" title="Link target outside of Sample">Fidelity to People and Place</span></p>
<p class="firstleft"><span href="#/Text/ch4#_idTextAnchor007" title="Link target outside of Sample">4 Patience</span></p>
<p class="body"><span href="#/Text/ch4#_idTextAnchor007" title="Link target outside of Sample">Entering into the Suffering of Others</span></p>
<p class="firstleft"><span href="#/Text/ch5#_idTextAnchor009" title="Link target outside of Sample">5 Wholeness</span></p>
<p class="body"><span href="#/Text/ch5#_idTextAnchor009" title="Link target outside of Sample">The Reconciliation of All Things</span></p>
<p class="firstleft"><span href="#/Text/ch6#_idTextAnchor011" title="Link target outside of Sample">6 Work</span></p>
<p class="body"><span href="#/Text/ch6#_idTextAnchor011" title="Link target outside of Sample">Cooperating with God’s Reconciling Mission</span></p>
<p class="firstleft"><span href="#/Text/ch7#_idTextAnchor013" title="Link target outside of Sample">7 Sabbath</span></p>
<p class="body"><span href="#/Text/ch7#_idTextAnchor013" title="Link target outside of Sample">The Rhythm of Reconciliation</span></p>
<p class="firstleft"><span href="#/Text/ch8#_idTextAnchor015" title="Link target outside of Sample">8 Abundance</span></p>
<p class="body"><span href="#/Text/ch8#_idTextAnchor015" title="Link target outside of Sample">The Economy of Creation</span></p>
<p class="firstleft"><span href="#/Text/ch9#_idTextAnchor017" title="Link target outside of Sample">9 Gratitude</span></p>
<p class="body"><span href="#/Text/ch9#_idTextAnchor017" title="Link target outside of Sample">Receiving the Good Gifts of God</span></p>
<p class="firstleft"><span href="#/Text/ch10#_idTextAnchor019" title="Link target outside of Sample">10 Hospitality</span></p>
<p class="body"><span href="#/Text/ch10#_idTextAnchor019" title="Link target outside of Sample">Generously Sharing God’s Abundance</span></p>
<p class="firstleft"><span href="#/Text/ch11#_idTextAnchor021" title="Link target outside of Sample">11 Dinner Table Conversation as a Way of Being Church</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/praise#_idTextAnchor022" title="Link target outside of Sample">Praise for <i class="i">Slow Church Study Guide</i></span></p>
<p class="firstleft"><span href="#/Text/authors#_idTextAnchor023" title="Link target outside of Sample">About the Authors</span></p>
<p class="firstleft"><span href="#/Text/moreIVP#_idTextAnchor024" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstleft"><span href="#/Text/copyright#_idTextAnchor025" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?bb9a112a